import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Grid, MenuItem } from "@mui/material";
import { useFormContext } from "react-hook-form";
import SearchableAutoComplete from "../../../../components/SearchableAutoComplete";
import useTenant from "../../../../hooks/useTenant";
import usePlanGroup from "../../../../hooks/usePlanGroup";

import CustomTextField from "../../../../components/CustomTextField";
import ReactHookFormSelect from "../../../../components/ReactHookFormSelect";
import useAuth from "../../../../hooks/useAuth";
import useBranch from "../../../../hooks/useBranch";

const currentTenantPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};
const currentPlanGroupPlanPayload = {
  filters: [],
  pagination: {
    pageNumber: 1,
    pageSize: 100,
  },
  sortFields: [],
};

function HotelUserFields(props) {
  const { user } = useAuth();
  const { t } = useTranslation();
  const { validationFields } = props;
  const {
    formState: { errors },
    control,
    watch,
  } = useFormContext();

  const selectedTenant = watch("tenant");

  const [branchPayload, setBranchPayload] = useState(currentTenantPayload);

  console.log(selectedTenant, "tenanthjddfgfd");

  const [tenantPayload, setTenantPayload] = useState(currentTenantPayload);
  const [tenantOptions, setTenantOptions] = useState([]);
  const { autoSearchTenant, tenantAutoSearchResults, getTenant, tenant } = useTenant();

  const { autoSearchPlanGroupPlan, planGroupPlanAutoSearchResults } = usePlanGroup();
  const [planGroupPlanPayload, setPlanGroupPlanPayload] = useState(currentPlanGroupPlanPayload);
  const [planGroupPlanOptions, setPlanGroupPlanOptions] = useState([]);
  const { autoSearchBranch, branchAutoSearchResults } = useBranch();

  const [branchOptions, setBranchOptions] = useState([]);

  // Branch
  const fetchBranch = async (payload) => {
    await autoSearchBranch(payload);
  };

  useEffect(() => {
    console.log(tenant, "tenanttenanttenant12444");
    if (tenant != null && Object.keys(tenant).length != 0) {
      const payload = {
        ...branchPayload,
        filters: [
          {
            fieldName: "tenantId",
            fieldValue: tenant.tenantId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
          },
        ],
      };

      fetchBranch(payload);
    }
  }, [tenant]);

  const fetchTenants = async () => {
    await autoSearchTenant(tenantPayload);
  };

  useEffect(() => {
    fetchTenants();
  }, [tenantPayload]);

  const fetchPlanGroupPlans = async (payloadValues) => {
    await autoSearchPlanGroupPlan(payloadValues);
  };

  const fetchTenantDetails = async () => {
    await getTenant(selectedTenant.value);
  };

  useEffect(() => {
    if (selectedTenant) {
      fetchTenantDetails();
    }
  }, [selectedTenant]);

  useEffect(() => {
    if (tenant) {
      let newPlanGroupPlanPayload = {
        ...planGroupPlanPayload,
        filters: [
          {
            fieldName: "planGroupId",
            fieldValue: tenant.planGroup?.planGroupId,
            op: "eq",
            dataType: "int",
            condition: "and",
            isJoin: true,
          },
        ],
      };
      setPlanGroupPlanPayload(newPlanGroupPlanPayload);
      fetchPlanGroupPlans(newPlanGroupPlanPayload);
    }
  }, [tenant]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (tenantAutoSearchResults.data.length !== 0) {
      const results = [...tenantOptions, ...tenantAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setTenantOptions(filteredResults);
    }
  }, [tenantAutoSearchResults]);

  useEffect(() => {
    //console.log(ispOptions, "ispOptions", ispAutoSearchResults);
    if (planGroupPlanAutoSearchResults.data.length !== 0) {
      const results = [...planGroupPlanOptions, ...planGroupPlanAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));
      setPlanGroupPlanOptions(filteredResults);
    }
  }, [planGroupPlanAutoSearchResults]);

  useEffect(() => {
    console.log(branchAutoSearchResults, "branchAutoSearchResults");
    if (branchAutoSearchResults && branchAutoSearchResults.data.length !== 0) {
      const results = [...branchOptions, ...branchAutoSearchResults.data];
      const filteredResults = results.filter(
        (value, index, self) => index === self.findIndex((t) => t.value === value.value),
      );
      filteredResults.sort((a, b) => a.label.localeCompare(b.label));

      //console.log([{ label: "All", value: "0" }, ...filteredResults], "opopopop");
      setBranchOptions([...filteredResults]);
    }
  }, [branchAutoSearchResults]);

  return (
    <Grid container spacing={6} className="row">
      {user &&
        (user.businessType === "SUPER_ADMIN" ||
          user.businessType == "DISTRIBUTOR" ||
          user.businessType == "MULTI_SERVICE_OPERATOR") && (
          <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
            <SearchableAutoComplete
              name="tenant"
              label={t("franchise_name")}
              control={control}
              data={tenantOptions}
              payload={tenantPayload}
              setPayload={setTenantPayload}
              loading={false}
              multiple={false}
              defaultValue={""}
              hasNextPage={false}
              fields={validationFields}
              fullWidth
              variant="outlined"
              errors={errors}
            ></SearchableAutoComplete>
          </Grid>
        )}
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <SearchableAutoComplete
          name="branch"
          label={t("branch_name")}
          control={control}
          data={branchOptions}
          payload={branchPayload}
          setPayload={setBranchPayload}
          loading={false}
          multiple={false}
          defaultValue={""}
          hasNextPage={false}
          fields={validationFields}
          fullWidth
          variant="outlined"
          errors={errors}
        ></SearchableAutoComplete>
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("user_name")}
          name="userName"
          type="text"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
          // disabled={true}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <SearchableAutoComplete
          control={control}
          data={planGroupPlanOptions}
          label={t("select_plan")}
          payload={planGroupPlanPayload}
          setPayload={setPlanGroupPlanPayload}
          loading={false}
          name="plan"
          multiple={false}
          defaultValue={""}
          hasNextPage={false}
          fields={validationFields}
          errors={errors}
        />
      </Grid>

      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("password")}
          name="password"
          type="password"
          my={2}
          control={control}
          fullWidth
          variant="outlined"
          errors={errors}
          fields={validationFields}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <CustomTextField
          label={t("name")}
          name="name"
          control={control}
          fullWidth
          variant="outlined"
          fields={validationFields}
          errors={errors}
        />
      </Grid>
      <Grid item xs={8.5} sm={4.5} md={6} lg={6} xl={6}>
        <ReactHookFormSelect
          name="status"
          label={t("Status")}
          control={control}
          fullWidth
          variant="outlined"
          fields={validationFields}
          errors={errors}
        >
          <MenuItem value={"ACTIVE"}>ACTIVE</MenuItem>
          <MenuItem value={"INACTIVE"}>INACTIVE</MenuItem>
        </ReactHookFormSelect>
      </Grid>
    </Grid>
  );
}

export default HotelUserFields;
